<template lang="pug">
div
  div.form-check.mb-3
    input#domain_check.form-check-input(type='checkbox', name='domain_check', @click='setDomainCheck', :checked="scope.domain_check", value=1)
    div.d-flex.align-items-center.mb-3
      label.form-check-label(for='domain_check') 同一ドメインからのリターン訪問による表示を無効にする
      span.upper-master-label.ml-2 Master以上
      UpgradeUpperMaster(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
</template>

<script>
//libs
import UpgradeUpperMaster from "../modals/upgrade_upper_master.vue";

export default {
  props: {
    show_with_parameters: { type: Boolean, default: false },
  },
  methods: {
    setDomainCheck(e){
      if (!this.show_with_parameters) {
        this.isDisplayModal(e);
      } else {
        this.$store.commit("creative/setDomainCheck", e.target.checked)
      }
    },
  },
  data(){
    return {
      is_upgrade_upper_master_modal: false,
    }
  },
  components: {
    UpgradeUpperMaster,
  },
  computed: {
    scope() {
      return {
        domain_check: this.$store.state.creative.preview_list.domain_check
      }
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
